import styled from 'styled-components'

export const Section = styled.section`
    color: ${(props) => {return props.theme.colorPrimary}};
    border-bottom: solid 4px #A7BABE;

    > div {
        max-width: 1300px;
        margin: auto;
    }
`
